import { render, staticRenderFns } from "./wtCopyLink.component.vue?vue&type=template&id=0b6a5e33&"
import script from "./wtCopyLink.component.vue?vue&type=script&lang=js&"
export * from "./wtCopyLink.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports